// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f801a73d","239":"020c1eff","453":"fbb08ab4","455":"62c851a3","762":"def77fcf"}[chunkId] + ".chunk.js";
};